import { render, staticRenderFns } from "./Disbursement.vue?vue&type=template&id=676b942d&"
import script from "./Disbursement.vue?vue&type=script&lang=js&"
export * from "./Disbursement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports